import { styled } from 'stitches.config';

export const Title = styled('h1', {
  textAlign: 'center',
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  width: '100%',
  maxWidth: '640px',
  margin: 'auto',

  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
  },
});

export const BodyWrapper = styled('div', {
  marginTop: '$2',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  '@bp2': {
    marginTop: '$4',
    textAlign: 'left',
  },

  '& a': {
    textDecoration: 'underline',
  },
});

export const EmphasisWrapper = styled('div', {
  marginTop: '$3',
  textAlign: 'center',
  '@bp2': {
    textAlign: 'left',
  },
});
